module.exports = __webpack_public_path__ + "static/media/PM64.35d0a6f2.JPG";